import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import boyImage from '../../images/boy.png';
import girlImage from '../../images/girl.png';

import Logout from '@mui/icons-material/Logout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../utils';
import { isEmpty } from 'lodash';

export default function ProfileDropDown({ user }) {
  const history = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirectAboutPage = () => {
    window.open('https://can.co/pages/about-us');
  };

  return (
    <React.Fragment>
      <Box>
        <Tooltip title="Profile">
          <div
            style={{
              display: 'flex',
              width: '161px',
              padding: '4px 12px 4px 4px',
              gap: '8px',
              alignItems: 'center',
              flexWrap: 'nowrap',
              backgroundColor: '#ffffff',
              borderRadius: '100px',
              position: 'relative',
              margin: '0 auto',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Avatar
              src={
                !isEmpty(user?.userInfo?.imageUrl)
                  ? user?.userInfo?.imageUrl
                  : user?.userInfo?.gender === 'female'
                    ? girlImage
                    : boyImage
              }
              sx={{
                width: '32px',
                height: '32px',
              }}
            />
            <span
              style={{
                height: '22px',
                flexShrink: '0',
                flexBasis: 'auto',
                fontFamily: 'Roboto, var(--default-font-family)',
                fontSize: '14px',
                fontWeight: '500',
                lineHeight: '22px',
                color: '#1d1d1f',
                textAlign: 'left',
                whiteSpace: 'nowrap',
                zIndex: '2',
                width: '100px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {user?.fullName || user?.userInfo?.firstName}
            </span>
            <ExpandMoreIcon
              style={{
                width: '18px',
                height: '18px',
                flexShrink: '0',
                backgroundPosition: 'center',
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
                position: 'relative',
                zIndex: '4',
              }}
            />
          </div>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => history('/edit-profile')}>
          <Avatar style={{ width: '30px', height: '30px', marginRight: '10px' }} /> Profile
        </MenuItem>
        <MenuItem onClick={redirectAboutPage}>
          <InfoIcon style={{ width: '30px', height: '30px', marginRight: '10px', color: '#bdbdbd' }} /> About CAN Care
        </MenuItem>
        <Divider />
        <MenuItem onClick={async () => await logout(history)}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}
